/// <reference path="../../typings/tsd.d.ts" /> 

module warsApp.services {

    export class ClaimDefinitionService extends warsApp.services.DataService<Wars.Domain.Model.ClaimDefinition> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http:angular.IHttpService) {
            super(injectedBreeze, $q);
            this.$q = $q;
        }

        public getAllProcessClaimsExecutionSide(processTypeId: string): ng.IPromise<Wars.Domain.Model.ClaimDefinition[]> {
            var parameters = {
                processTypeId: processTypeId
            };

            const query = this.breezeModule.EntityQuery
                .from("ClaimDefinitionsCustom")
                .withParameters(parameters);

            return this.executeQuery(query);
        }

        public getAllProcessClaims(processConfigurationId: string): ng.IPromise<Wars.Domain.Model.ClaimDefinition[]> {
            const query = this.breezeModule.EntityQuery
                .from("ClaimDefinitions")
                .where('processConfiguration_id', '==', processConfigurationId)
                .expand("myOnAssignProcessAction, myOnUnAssignProcessAction")
                .orderBy("type");

            return this.executeQuery(query);
        }

        public getAllProcessAndSystemClaims(processConfigurationId: string): ng.IPromise<Wars.Domain.Model.ClaimDefinition[]> {
            var pred = this.breezeModule.Predicate
                .create('processConfiguration_id', '==', processConfigurationId)
                .or('processConfiguration_id', '==', null);

            const query = this.breezeModule.EntityQuery
                .from("ClaimDefinitions")
                .where(pred)
                .orderBy("type");

            return this.executeQuery(query);
        }

        public getApiProcessClaims(processConfigurationId: string): ng.IPromise<Wars.Domain.Model.ClaimDefinition[]> {
            var d = this.$q.defer();
            this.$http.get('./api/claims/' + processConfigurationId) .then(result => {
                    d.resolve(result.data);
                });

            return d.promise;
        }

        public getUserRepositoryComponents(): ng.IPromise<string[]> {
            var d = this.$q.defer();
            this.$http.get('./api/ExtensibleComponent/GetExternalUserRepositories').then(result => {
                d.resolve(result.data);
            });
            return d.promise;
        }

        public getById(id: string): ng.IPromise<Wars.Domain.Model.ClaimDefinition> {
            return this.fetchById(id, "ClaimDefinition");
        }
    }
}

warsApp.registerService('ClaimDefinitionService', ['breeze', '$q','$http']);